import React from "react";
import { observer } from "mobx-react";
import { Link } from "react-router";
import { routes } from "modules/common/routes";
import { SimpleMessage, SimpleMessageProps } from "./SimpleMessage";

/**
 * Согласование сдвига по связям в плане (этап 6.5 «Графики»): ГИПу — запрос, автору — решение.
 * Ссылка открывает плановый график на запросе: предложенное место там видно контуром
 */
export const PlanApprovalMessage = observer((props: SimpleMessageProps) => {
    const { message, ...rest } = props;
    const approvalId = message.data.get("ApprovalId");

    return (
        <SimpleMessage message={message} {...rest}>
            <Link
                to={
                    approvalId ? `${routes.schedules.projectPlan}?approval=${approvalId}` : routes.schedules.projectPlan
                }
            >
                Открыть плановый график
            </Link>
        </SimpleMessage>
    );
});
